import { ZakaznickaKategorie } from './zakaznickaKategorie';
import { ZakaznickaSkupina } from './zakaznickaSkupina';
import { ZakaznickyTitul } from './zakaznickyTitul';
import { ZarazeniZakaznik } from './zarazeniZakaznik';
import { Department } from './Department';
import { ChargeType } from './ChargeType';

export const menu = {
	name: 'CiselnikZakaznicke',
	list: [
		{ name: 'pZakTitul', route: ZakaznickyTitul.name },
		{ name: 'ZakaznickaKategorie', route: ZakaznickaKategorie.name },
		{ name: 'ZakVaria', route: ZarazeniZakaznik.name },
		{ name: 'pZakazniksk', route: ZakaznickaSkupina.name },
		{ name: 'Department' , route: Department.name },
		{ name: 'ChargeType' , route: ChargeType.name },
	],
};
